// Copied from frontend/src/lib/theme.ts — cloud uses its own storage key.
type Theme = "light" | "dark";
const KEY = "icc.theme";

export function initTheme() {
  const saved = (localStorage.getItem(KEY) as Theme | null) ?? null;
  const prefers: Theme =
    window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
  setTheme(saved ?? prefers);
}

export function getTheme(): Theme {
  return (document.documentElement.getAttribute("data-theme") as Theme) || "dark";
}

export function setTheme(t: Theme) {
  document.documentElement.setAttribute("data-theme", t);
  localStorage.setItem(KEY, t);
}

export function toggleTheme() {
  setTheme(getTheme() === "dark" ? "light" : "dark");
}
